import styled from 'styled-components';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useBusinessPartnerInvoiceDetails, useSubscription } from 'Hooks';
import { Invoice, SubscriptionDetails } from 'Types';
import {
	Card,
	InvoicePayment,
	DetailsInvoice,
	DetailsSubscriptionInvoice
} from 'Elements';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

const InvoiceCard = styled(Card)`
	height: 100%;
	min-height: 250px;
`;

interface Props {
	isLoadingSubscriptionPayments: boolean;
}

export const ViewInvoice: FC<Props> = ({ isLoadingSubscriptionPayments }) => {
	const { t } = useTranslation();
	const { invoice_id } = useParams();

	const { data: transaction } = useBusinessPartnerInvoiceDetails(
		invoice_id ?? '',
		{
			enabled: !!invoice_id
		}
	);

	const { data: subscription, isLoading } = useSubscription(
		transaction?.subscriptionId as string,
		{
			enabled: !!transaction?.subscriptionId
		}
	);

	return (
		<>
			<Row className="mb-4">
				<Col md={6}>
					<InvoiceCard>
						<DetailsInvoice
							transaction={transaction as Invoice}
							isLoading={isLoadingSubscriptionPayments ?? isLoading}
						/>
					</InvoiceCard>
				</Col>
				<Col md={6} className="mt-4 mt-md-0">
					<InvoiceCard>
						<InvoicePayment
							transaction={transaction as Invoice}
							isLoading={isLoadingSubscriptionPayments ?? isLoading}
						/>
					</InvoiceCard>
				</Col>
			</Row>
			<Card>
				<h6 className="text-gray-3 mb-3 fs-6 fw-400">
					{t('title.product')}
				</h6>
				{subscription && (
					<DetailsSubscriptionInvoice
						showPrice={false}
						subscription={subscription as SubscriptionDetails}
						name={transaction?.subscriptionPlanInfo?.name as string}
						code={
							transaction?.subscriptionPlanInfo
								?.subscriptionPlanCode as string
						}
						subscriptionId={subscription?.id as string}
						communityPartnerInfo={
							subscription?.communityPartnerInfo
						}
						isLoading={isLoading}
						canAutoRenew={false}
					/>
				)}
			</Card>
		</>
	);
};
